import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HeaderBar from 'components/headerBar';
import Carousel from 'components/Carousel';
import { BulkNotifications } from 'views/shared/Notifications';
import {
  Badge, Button, Icon, message, Tooltip
} from 'antd';
import { remove } from 'actions';
import ToolBar from 'components/toolBar';
import RosterVersion from './Provider';

const mapDispatchToProps = (dispatch, props) => ({
  removeNotifications(data) {
    return dispatch(remove(props.reducer.key, data));
  }
});

const NotificationsPanel = ({
  headerTitle, itemRenderer, items, onCancel, onDelete, onDeselect, onSave, reducer, removeNotifications, removeButtonText, removeText, selectedObjects, selectedItems, themeName, title
}) => {
  const handleRemove = (rosterVersion) => {
    removeNotifications({
      id: [].concat(...items.filter(item => selectedObjects.includes(item.id))
        .map(item => item.notifications))
        .map(i => i.id),
      version_id: rosterVersion
    })
      .then((response) => {
        message.success('Notifications removed successfully');
        onDelete(response);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  return (
    <>
      <div>
        <BulkNotifications onSave={onSave} onCancel={onCancel} reducer={reducer} title={title} themeName={themeName} objects={selectedObjects} />
      </div>
      <HeaderBar
        title={[<Badge key={selectedObjects.length} count={selectedObjects.length} />, ' ', headerTitle]}
        toolbar={(
          <ToolBar>
            <ToolBar.Right>
              {removeText}
              <Tooltip title={removeText} placement="bottom">
                <RosterVersion.Consumer>
                  {({ rosterVersion }) => (
                    <Button type="primary" size="small" icon="delete" onClick={() => handleRemove(rosterVersion)}>{removeButtonText}</Button>
                  )}
                </RosterVersion.Consumer>
              </Tooltip>
            </ToolBar.Right>
          </ToolBar>
        )}
      />
      <Carousel
        columns={6}
        extra={item => (
          <a onClick={() => onDeselect(item.key)}>
            <Icon type="select" />
            {' '}
            Deselect
          </a>
        )}
        items={selectedItems}
        style={{ marginBottom: '20px' }}
        itemRenderer={item => itemRenderer(item)}
      />
    </>
  );
};

NotificationsPanel.propTypes = {
  headerTitle: PropTypes.string,
  itemRenderer: PropTypes.func,
  items: PropTypes.array,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  onDeselect: PropTypes.func,
  onSave: PropTypes.func,
  removeText: PropTypes.string,
  reducer: PropTypes.object,
  removeButtonText: PropTypes.string,
  removeNotifications: PropTypes.func,
  selectedObjects: PropTypes.array,
  selectedItems: PropTypes.array,
  themeName: PropTypes.string,
  title: PropTypes.string
};

NotificationsPanel.defaultProps = {
  headerTitle: 'Selected Assignments',
  itemRenderer() {
  },
  items: [],
  onCancel() {
  },
  onDelete() {
  },
  onDeselect() {
  },
  onSave() {
  },
  removeText: 'Remove all notifications from selected activities',
  reducer: {},
  removeButtonText: 'Remove',
  removeNotifications() {
  },
  selectedObjects: [],
  selectedItems: [],
  themeName: '',
  title: 'Notification'
};

export default connect(null, mapDispatchToProps)(NotificationsPanel);
